import { render } from "./DailyCollectionsReport.vue?vue&type=template&id=a3132a68&scoped=true"
import script from "./DailyCollectionsReport.vue?vue&type=script&lang=js"
export * from "./DailyCollectionsReport.vue?vue&type=script&lang=js"

import "./DailyCollectionsReport.vue?vue&type=style&index=0&id=a3132a68&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3132a68"]])

export default __exports__